
















import UserUseCases from '@/modules/Config/GeneralUserConfiguration/application/UserUseCases'
import { dataToUpdateUser } from '@/modules/Config/GeneralUserConfiguration/domain/UserController'
import UserController from '@/modules/Config/GeneralUserConfiguration/infrastructure/controller/User.controller'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('UserStore', ['token', 'user']),
    ...mapState('AppStore', ['selectedApp'])
  },
  data () {
    return {
      userController: new UserController(),
      loadingUpdate: false
    }
  },
  methods: {
    async goToNewVersion () {
      await this.updateUserExtradataModal()
      window.open(`${process.env.VUE_APP_SMARTCHAT_URL}?token=${this.token}&appUUID=${this.selectedApp?.uuid}`, '_self')
    },
    async updateUserExtradataModal () {
      try {
        this.loadingUpdate = true
        const data: dataToUpdateUser = {
          uuid: this.user?.uuid,
          token: this.token,
          updateInput: {
            appUUID: this.selectedApp?.uuid,
            extradata: [
              ...this.user.userData?.map(ud => ({ property: ud.property, value: ud.value })) || [],
              {
                property: 'v7_pop_up',
                value: 'true'
              }
            ]
          }
        }
        await UserUseCases.updateUser(this.userController, data)
        this.loadingUpdate = false
      } catch (e) {
        console.error(e)
      }
    },
    async updateUserExtradataVersion () {
      try {
        this.loadingUpdate = true
        const data: dataToUpdateUser = {
          uuid: this.user?.uuid,
          token: this.token,
          updateInput: {
            appUUID: this.selectedApp?.uuid,
            extradata: [
              ...this.user.userData?.map(ud => ({ property: ud.property, value: ud.value })) || [],
              {
                property: 'stay_in_v7',
                value: 'false'
              }
            ]
          }
        }
        await UserUseCases.updateUser(this.userController, data)
        this.$emit('cancel')
        this.$emit('close')
        this.loadingUpdate = false
      } catch (e) {
        console.error(e)
        this.$emit('cancel')
        this.$emit('close')
      }
    }
  }
}
